import { z } from 'zod';
export const HydrateRunStatusSchema = z.enum(['RUNNING', 'SUCCEEDED', 'FAILED']);
export const HydrateOrgRequestBodySchema = z.object({
    doWipeDatabase: z.boolean().optional(),
});
export const HydrateOrgRequestSchema = HydrateOrgRequestBodySchema;
export const HydrateOrgResponseSchema = z.object({
    executionArn: z.string(),
    status: HydrateRunStatusSchema,
});
export const HydrateOrgApiSchema = {
    body: HydrateOrgRequestBodySchema,
    response: HydrateOrgResponseSchema,
};
